import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import { useServiceRequest } from '../../../components/ServiceStatusProvider';

const HeroSection = () => {
  const navigate = useNavigate();
  const { requestCleaning } = useServiceRequest();

  return (
    <div className="bg-card rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl p-6 sm:p-8 lg:p-12">
      <div className="grid gap-8 lg:grid-cols-2 lg:gap-12 items-center">
        <div className="space-y-6">
          <div className="inline-flex items-center gap-2 bg-blue-100 px-4 py-2 rounded-full">
            <Icon name="Sparkles" size={20} color="#2563EB" />
            <span className="text-sm font-medium text-primary">일상 속 신발 케어</span>
          </div>
          
          <h1 className="text-5xl sm:text-5xl lg:text-5xl font-bold text-foreground leading-tight">
            가까운 케어
            <br />
            <span className="text-primary">올바른 손질</span>
          </h1>
          
          <p className="text-lg text-muted-foreground leading-relaxed">
      

            소중한 신발을 소재별로 세심하게<br/>
손세탁으로 꼼꼼하게 클리닝합니다<br/>
픽업부터 반납까지, 편리하게 이용하세요.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              variant="default"
              size="lg"
              iconName="Calendar"
              iconPosition="right"
              onClick={() => requestCleaning()}
              className="w-full sm:w-auto bg-gradient-to-r from-blue-500 to-blue-600 text-white hover:from-blue-600 hover:to-blue-700 shadow-lg hover:shadow-xl focus:ring-2 focus:ring-blue-300">

              세탁 서비스 신청하기
            </Button>
            
            <Button
              variant="outline"
              size="lg"
              iconName="DollarSign"
              iconPosition="left"
              onClick={() => navigate('/price-guide')}
              className="w-full sm:w-auto border-blue-500 text-blue-600 bg-transparent hover:bg-transparent hover:text-blue-600">

              가격 안내 보기
            </Button>
          </div>
          
          <div className="flex items-center gap-6 pt-4">
            <div className="flex items-center gap-2">
              <Icon name="CheckCircle2" size={20} color="var(--color-success)" />
              <span className="text-sm text-muted-foreground">신내동 무료 수거·반납</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Shield" size={20} color="var(--color-success)" />
              <span className="text-sm text-muted-foreground">소재별 맞춤 케어</span>
            </div>
          </div>
        </div>
        
        {/* <div className="relative">
          <div className="aspect-square rounded-2xl overflow-hidden bg-muted">
            <Image
              src="/assets/sneakercare-img.png"
              alt="Clean white sneakers displayed on wooden surface with professional lighting showing pristine condition and detailed texture"
              className="w-full h-full object-cover" />

          </div>
        </div> */}
      </div>
    </div>);

};

export default HeroSection;